import React, { useEffect, useState } from 'react'

import TransparentPricingC from '@src/quince-components/src/atoms/transparentPricing'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import pdpStateManager from '@src/quince-site-common/src/redux/globalStateManager/PDPStateManager'
import { useAppSelector } from '@src/quince-site-common/src/redux/hooks'
import { ProductSectionType } from '@src/quince-site-pdp/src/types/productPage.types'

import ProductPageSectionProps from '../../../domains/ProductPageSectionProps'

import { shouldHideTransparentPricing } from './TransparentPricing'
import styles from './transparentPricing.module.scss'

const TransparentPricingProduct = (props: ProductPageSectionProps) => {
  const transparentPricingSectionData = props.sectionData[ProductSectionType.TRANSPARENT_PRICING]
  const selectedOptions = useAppSelector<ProductVariantOption[]>(pdpStateManager, pdpStateManager.getSelectedOptions)

  const [quincePrice, setQuincePrice] = useState(transparentPricingSectionData.quincePrice)
  const [traditionalPrice, setTraditionalPrice] = useState(transparentPricingSectionData.traditionalPrice)

  useEffect(() => {
    setQuincePrice(productHelper.getQuincePriceForOptions(props.product, selectedOptions))
    setTraditionalPrice(productHelper.getTraditionalPriceForOptions(props.product, selectedOptions) ?? 0)
  }, [selectedOptions, props.product])

  const costsForVariant = productHelper.getTransparentPricingCostsForProduct(
    props.product,
    selectedOptions,
    transparentPricingSectionData.uniquePricingMap,
    transparentPricingSectionData.variantIdToUniqueMap,
  )

  const getTransparentPricingItems = () => {
    const transparentPricingItems = [
      {
        name: 'Materials',
        value: (costsForVariant?.materials ?? 0) + (costsForVariant?.hardware ?? 0),
      },
      {
        name: 'Crafting Cost',
        value: costsForVariant?.crafting ?? 0,
      },
      {
        name: 'Packaging',
        value: costsForVariant?.packaging ?? 0,
      },
      {
        name: 'Freight & Handling',
        value: costsForVariant?.shippingHandling ?? 0,
      },
      {
        name: 'Credit card Fees',
        value: costsForVariant?.creditCardFees ?? 0,
      },
    ]
    if (costsForVariant?.dutyFee) {
      transparentPricingItems.push({
        name: 'Duties, Taxes, And Fees',
        value: costsForVariant.dutyFee ?? 0,
      })
    }
    if (costsForVariant?.sockDonationCost) {
      return [
        ...transparentPricingItems,
        {
          name: 'Sock donation',
          value: costsForVariant.sockDonationCost,
        },
      ]
    }
    return transparentPricingItems
  }

  if (shouldHideTransparentPricing(props.product)) return null
  return (
    <div className={styles.transparentPricing}>
      <TransparentPricingC
        items={getTransparentPricingItems()}
        quincePrice={quincePrice}
        traditionalPrice={traditionalPrice || 0}
      />
    </div>
  )
}

export default TransparentPricingProduct
